import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { Box, Typography } from "@mui/material";
import { RoundActionIconButton } from "../../components/Buttons/ActionIconButton/RoundActionIconButton";
import { useEffect, useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Editor from "react-simple-code-editor";
import Prism from "prismjs";
import "prismjs/components/prism-python";
import "prismjs/themes/prism-okaidia.css";
const PythonCodeEditor = ({ value, onChange, disabled }) => {
    return (_jsx(Box, Object.assign({ sx: {
            "& .token.operator": {
                background: "transparent",
                color: "white",
            },
        } }, { children: _jsx(Editor, { value: value, onValueChange: onChange, highlight: (code) => Prism.highlight(code, Prism.languages.python, "python"), padding: 12, style: {
                // border: "1px solid #ccc",
                // background: disabled ? "#f5f5f5" : "#fff",
                // color: "black",
                //   fontFamily: "monospace",
                //   fontSize: 14,
                //   border: "1px solid #ccc",
                // background: disabled ? "#f5f5f5" : "auto",
                pointerEvents: disabled ? "none" : "auto",
                //   minHeight: 100,
                //   caretColor: "#fafafa",
                //   color: "#fafafa",
                fontFamily: 'Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace',
                fontSize: "1em",
                lineHeight: "1.5",
                caretColor: "#fff",
                overflow: "auto",
                background: "rgb(39, 40, 34)",
            }, readOnly: disabled }) })));
};
export function EditCodeComponent({ codeString, disabled, acceptEditedCode, cancelEditMode, }) {
    const [code, setCode] = useState(codeString);
    useEffect(() => {
        setCode(codeString);
    }, [codeString]);
    return (_jsxs(Box, Object.assign({ sx: {
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            display: "flex",
            background: "rgb(39, 40, 34)",
            borderRadius: "0.3em",
            overflowX: "auto",
        } }, { children: [_jsx(PythonCodeEditor, { value: code, onChange: setCode, disabled: false }), _jsxs(Box, Object.assign({ sx: {
                    display: "flex",
                    px: 1,
                    pb: 1,
                    pt: "4px",
                    alignItems: "center",
                    position: "sticky",
                    left: 0,
                    backgroundColor: "rgb(39, 40, 34)", // Match parent background
                } }, { children: [_jsx(Typography, Object.assign({ variant: "caption", color: " #b3b3b3", sx: { mr: 1 } }, { children: "Edit code" })), _jsx(RoundActionIconButton, Object.assign({ size: "small", tooltipMsg: "Cancel", onClick: cancelEditMode, baseColor: "#ffffff", disabled: disabled }, { children: _jsx(CloseIcon, { sx: { fontSize: "1rem" } }) })), _jsx(RoundActionIconButton, Object.assign({ size: "small", tooltipMsg: "Accept", onClick: () => {
                            acceptEditedCode(code);
                        }, baseColor: "#ffffff", disabled: disabled }, { children: _jsx(CheckIcon, { sx: { fontSize: "1rem" } }) }))] }))] })));
}
